"use client";

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { getUsageSummary, UsageSummary } from '../lib/api';

export const useUsageSummary = (month?: string) => {
    const { getToken, isSignedIn } = useAuth();

    return useQuery<UsageSummary>({
        queryKey: ['usage-summary', month],
        enabled: isSignedIn,
        queryFn: async () => {
            const token = await getToken();
            if (!token) throw new Error('Not authenticated');
            return getUsageSummary(token, month);
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
